import { userService, service } from './service';
import store from '@/store/index';
/**
 * @description 登录
 * @param {Object} data 登录携带的信息
 */

export function SYS_USER_LOGIN() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return userService({
    url: 'Auth/GetToken',
    data: data,
    method: 'post'
  });
}
export function getBuyerList(params) {
  return userService({
    url: 'Manager/LoadData',
    params: params,
    method: 'get'
  });
}
export function getRoleList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return userService({
    url: 'Manager/AddOrModify',
    method: 'get'
  });
}
export function getVenderList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return userService({
    url: 'Manager/LoadDataForVendor',
    params: data,
    method: 'get'
  });
} // 获取验证码

export function GetCaptcha() {
  return userService({
    url: 'Captcha/Get',
    method: 'get'
  });
} // 获取组织ID

export function GetOrg() {
  return service({
    url: 'SysOrganize/GetOrg',
    method: 'get'
  });
} // 获取用户列表

export function page(query) {
  return userService({
    // url: 'Manager/LoadData',
    url: 'Manager/LoadScmData',
    method: 'get',
    params: query
  });
} // 获取角色列表

export function rolelist(query) {
  return userService({
    url: 'Manager/AddOrModify',
    method: 'get',
    params: query
  });
} // 删除用户

export function Delete(obj) {
  return userService({
    url: 'Manager/Delete?id=' + obj,
    method: 'POST'
  });
} // 编辑和添加用户实验效

export function IsExistsName(obj) {
  return userService({
    url: 'Manager/IsExistsName',
    method: 'POST',
    data: obj
  });
} // 编辑和添加用户

export function putObj(obj) {
  return userService({
    url: 'Manager/AddOrModifySave',
    method: 'POST',
    data: obj
  });
} // 修改用户状态

export function Status(obj) {
  return userService({
    url: 'Manager/ChangeLockStatus',
    method: 'POST',
    data: obj
  });
}
/**
 * 重置密码
 * @param {Object} data
 */

export function ResetPassword(data) {
  return userService({
    url: 'Manager/ResetPassword',
    data: data,
    method: 'post'
  });
}
/**
 * @description 导出数据
 * @param {Object} data
 */

export function ExportListData(params) {
  return userService({
    url: 'Manager/ExportListData',
    method: 'get',
    params: params
  });
}
/**
 * @description 获取采购员导入模板文件
 * @param {Object} data
 */

export function GetImportTplUrlForPurchase(params) {
  return userService({
    url: 'Manager/GetImportTplUrlForPurchase',
    method: 'get',
    params: params
  });
}
/**
 * @description 采购员注册批量导入功能
 * @param {Object} data
 */

export function PurchaseImportData(data) {
  return userService({
    url: 'Manager/PurchaseImportData',
    method: 'post',
    data: data
  });
}
/**
 * @description 获取供应商导入模板文件
 * @param {Object} data
 */

export function GetImportTplUrlForVendor(params) {
  return userService({
    url: 'Manager/GetImportTplUrl',
    method: 'get',
    params: params
  });
}
/**
 * @description 供应商注册批量导入功能
 * @param {Object} data
 */

export function VendorImportData(data) {
  return userService({
    url: 'Manager/VendorImportData',
    method: 'post',
    data: data
  });
} //修改密码

export function ChangePassword(data) {
  return userService({
    url: 'Manager/ChangePassword',
    method: 'post',
    data: data
  });
} //查询用户导出列表

export function ExportFileList(params) {
  return userService({
    url: 'Manager/ExportFileList',
    method: 'get',
    params: params
  });
} //删除导出数据

export function DeleteExportFileData(data) {
  return userService({
    url: 'Manager/ExportFileDelete',
    method: 'post',
    data: data
  });
}